import React, { useState } from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';

type Props = {
  onClick?: () => void;
  label?: string;
  /** When true, renders inline (right-aligned) instead of floating fixed */
  inline?: boolean;
};

export default function VelaChatButton({ onClick, label = 'Ask Vela', inline = false }: Props) {
  const [hovered, setHovered] = useState(false);

  const positionStyle: React.CSSProperties = inline
    ? { display: 'flex', justifyContent: 'flex-end', marginTop: 28 }
    : { position: 'fixed', right: 24, bottom: 24, zIndex: 40 };

  return (
    <div style={positionStyle}>
      <button
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onClick}
        style={{
          background: hovered ? '#2A3A3A' : C.ink,
          color: '#fff',
          padding: '10px 16px 10px 10px',
          borderRadius: 999,
          border: 0,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
          fontFamily: F.family,
        }}
      >
        <span style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, ' + C.vela + ', #8B5CF6)',
          display: 'grid',
          placeItems: 'center',
          fontWeight: 700,
          fontSize: 13,
        }}>V</span>
        {label}
      </button>
    </div>
  );
}
